export const CSRF_STORAGE_KEY = "dark-admin-csrf";

export const csrfRequestConfig = (token) => ({
  withCredentials: true,
  headers: token ? { "X-CSRF-Token": token } : {},
});

export const restoreAdminSession = async (client, apiBase, csrfToken) => {
  try {
    const { data } = await client.get(`${apiBase}/auth/me`, {
      withCredentials: true,
    });
    return data;
  } catch (error) {
    if (error.response?.status !== 401 || !csrfToken) {
      throw error;
    }
  }

  const { data: refreshData } = await client.post(
    `${apiBase}/auth/refresh`,
    {},
    csrfRequestConfig(csrfToken)
  );
  const { data: currentUser } = await client.get(`${apiBase}/auth/me`, {
    withCredentials: true,
  });
  return {
    ...currentUser,
    csrf_token: currentUser.csrf_token || refreshData.csrf_token,
  };
};

export const rememberCsrfToken = (token, storage = window.sessionStorage) => {
  if (token) {
    storage.setItem(CSRF_STORAGE_KEY, token);
  } else {
    storage.removeItem(CSRF_STORAGE_KEY);
  }
  return token || "";
};

export const adminPhotoUrl = (apiBase, request, key) =>
  request.photo_urls?.[key] || `${apiBase}/uploads/${key}`;
